import { IOptions } from 'sanitize-html';

import { mergeSanitizationProfiles } from '../mergeSanitizationProfiles/mergeSanitizationProfiles';

/**
 * Creates a sanitization profile.
 *
 * This includes the basic tags to allow multiline as every textual channel is
 * capable of adding newlines. The editor itself creates some of these elements
 * upon pressing enter.
 *
 * The schemes are only used if the profile includes tags with resources such as
 * anchors or images.
 *
 * @param options The sanitization options.
 */
export function createSanitizationProfile(options: IOptions): IOptions {
  return mergeSanitizationProfiles(options, {
    allowedTags: ['div', 'p', 'br'],
    allowedSchemes,
  });
}

/** Represents allowed feature schemes. */
export const allowedFeatureSchemes = ['mailto', 'tel', 'callto'] as const;

/** Represents all allowed schemes. */
export const allowedSchemes = [
  ...allowedFeatureSchemes,
  'http',
  'https',
  // We use this so that links open inside the electron app.
  'dixa',
  // Custom schemes
  'dynamicsnav', // Microsoft Dynamics NAV
  'ms-dynamicsnav', // Microsoft Dynamics NAV
  'kartenmacherei', // Used by Celebrate
] as const;

/**
 * The grouping of html tags that share the same meaning or is otherwise
 * dependant on one another. Furthermore we don't support one without the others
 * in a group.
 */
export const htmlTagGroups = {
  strikethrough: ['strike', 'del', 's'],
  italic: ['i', 'em'],
  bold: ['b', 'strong'],
  heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
  list: ['ul', 'ol', 'li'],
  descriptiveList: ['dl', 'dt'],
  select: ['select', 'option', 'optgroup'],
  inlineCode: ['code', 'kbd', 'samp', 'var', 'tt'],
  blockCode: ['pre'],
  table: [
    'caption',
    'col',
    'colgroup',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'tr',
  ],
};
